import React from "react";

import {
  useRetrieveCurrentPlanzone,
  useRetrieveZonesIndicators,
} from "@planzone/view-models";
import { Flag, InfiniteScroll } from "@common/infiniteScroll";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { useModal } from "@root/client/modal";
import { AddZoneButton } from "./addZoneButton";
import { Placeholder } from "./placeholder";
import { Heading } from "./heading";
import { Zone } from "./zone";
import { Loader } from "./loader";
import { Props } from "./types";
import styles from "./styles.scss";

function ZonesPage(props: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const filter = {
    projects: [],
    projectStatuses: [],
    projectsTags: [],
  };
  const {
    zones,
    isRequestPending,
    canRetrieveNextZonesIndicators,
    index,
    retrieveZonesIndicators,
  } = useRetrieveZonesIndicators(filter, "ascendingName", 10);
  const { pushView } = useModal();

  return (
    <div className={styles.projectsPage}>
      <Safeguard useCases={[UseCases.createZone]}>
        {({ canCreateZone }) =>
          canCreateZone && (
            <div className={styles.header}>
              <div
                className={styles.addZoneButton}
                onClick={() =>
                  pushView({ key: UseCases.createZone, data: planzone })
                }
              >
                <AddZoneButton />
              </div>
            </div>
          )
        }
      </Safeguard>
      <div className={styles.zones}>
        <Heading />
        <InfiniteScroll canFetchOnIdle>
          {() => (
            <>
              <ul className={styles.list}>
                {zones.map((zone) => (
                  <li key={zone.uuid} className={styles.item}>
                    <Zone zone={zone} />
                  </li>
                ))}
              </ul>
              {isRequestPending && <Loader />}
              <Flag
                name="zones"
                isDisabled={isRequestPending || !canRetrieveNextZonesIndicators}
                retrieveItems={() =>
                  !isRequestPending &&
                  retrieveZonesIndicators({
                    filter,
                    index,
                    sort: "ascendingName",
                    size: 10,
                  })
                }
              />
              {zones.length === 0 && !isRequestPending && <Placeholder />}
            </>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
}

export { ZonesPage };
